// Acciones de navegación para los avisos de proceso del sistema (esProceso === true),
// indexadas por el campo `tipoProceso` del aviso (valores en minúsculas desde backend,
// ej. "desasignacion_libros", "reporte_sugerencias").
//
// Cada entrada define:
//   - label: texto del botón de acción.
//   - getNavigation(referenciaId): destino de navegación ({ to, state }).
//
// Si un `tipoProceso` no está aquí, el modal de proceso solo muestra el botón
// "Entendido" (ej. "desasignacion_libros", que es puramente informativo).
// Para habilitar la navegación de un nuevo tipo, basta con agregar su entrada aquí.
export const PROCESO_ACCIONES = {
  reporte_sugerencias: {
    label: "Ver reporte",
    getNavigation: (referenciaId) => ({
      to: "/herramientas/reporte-sugerencias",
      state: referenciaId ? { openReportId: referenciaId } : undefined,
    }),
  },
};

export const getProcesoAccion = (tipoProceso) =>
  (tipoProceso && PROCESO_ACCIONES[tipoProceso.toLowerCase()]) || null;

// Los avisos generados por procesos del sistema no se listan en las pantallas
// de gestión, historial ni reportes: solo le llegan al usuario como
// notificación. "Reporte de lección" se identifica por nombre porque es
// anterior al campo `esProceso`. Mismo criterio que usan GestorAvisosHome e
// HistorialAvisosHome.
export const esAvisoDeProceso = (aviso) =>
  (aviso?.esProceso && aviso?.tipoProceso === "reporte_sugerencias") ||
  aviso?.nombre === "Reporte de lección";
